export function interoStringaCifre(numero, cifre) {
    let s = String(numero);
    while (s.length<cifre) s = "0" + s;
    return s;
}

// param="" -> converte date dal formato YYYY-MM-DD al formato DD/MM/YYYY
// param="gSett" -> converte date dal formato YYYY-MM-DD al formato GIORNO DD/MM/YYYY con GIORNO = lunedì, martedì,...
// param="gSettAbbr" -> converte date dal formato YYYY-MM-DD al formato GIORNO DD/MM/YYYY con GIORNO = lun, mar, mer,...
export function convertiDataComputer2Umano(d, param) {
    if (d==""||d==null) return "";
    const ds = d.split("-");
    if (param=="") return ds[2]+"/"+ds[1]+"/"+ds[0];
    const giornoSettimana = new Date(d).getDay();
    const giorni = ["domenica","lunedì","martedì","mercoledì","giovedì","venerdì","sabato"];
    const giorniAbbr = ["dom","lun","mar","mer","gio","ven","sab"];
    if (param=="gSett") return giorni[giornoSettimana] + " " + ds[2]+"/"+ds[1]+"/"+ds[0];
    return giorniAbbr[giornoSettimana] + " " + ds[2]+"/"+ds[1]+"/"+ds[0];
}

export function convertiImportoComputer2Umano(i) {
  // Gestione valori vuoti
  if (i === null || i === undefined || i === '') return '';

  // Normalizza in numero
  let num;
  if (typeof i === 'number') {
    num = i;
  } else {
    let s = String(i).trim();

    // Determina separatore decimale se ci sono . e/o ,
    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    let decimalSep = null;
    let thousandsSep = null;

    if (lastComma !== -1 && lastDot !== -1) {
      // Quello più a destra è il decimale, l'altro è migliaia
      decimalSep = lastComma > lastDot ? ',' : '.';
      thousandsSep = decimalSep === ',' ? '.' : ',';
    } else if (lastComma !== -1) {
      decimalSep = ',';
    } else if (lastDot !== -1) {
      decimalSep = '.';
    }

    if (thousandsSep) {
      // Rimuovi tutti i separatori delle migliaia
      const re = new RegExp(`\\${thousandsSep}`, 'g');
      s = s.replace(re, '');
    }

    if (decimalSep && decimalSep !== '.') {
      // Converte il separatore decimale in punto per parseFloat
      const re = new RegExp(`\\${decimalSep}`, 'g');
      // Solo l'ULTIMO separatore è decimale: sostituisci l'ultimo con punto, gli altri (se presenti) già rimossi sopra
      const idx = s.lastIndexOf(decimalSep);
      if (idx !== -1) s = s.slice(0, idx) + '.' + s.slice(idx + 1);
      // (in pratica il replace globale non serve più se abbiamo trattato migliaia)
    }

    num = parseFloat(s);
  }

  if (!Number.isFinite(num)) return '';

  // Arrotonda e formatta in stile italiano: . per migliaia, , per decimali
  return new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
}

export function oggiData() {
    return new Date().toISOString().split('T')[0];
}

export function oggiDataOra() {
    return new Date().toISOString();
}